import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './store/authStore';
import { Shell } from './components/Shell';
import AuthPage from './features/auth';
import DashboardPage from './features/dashboard';
import MapPage from './features/map';
import DataPage from './features/data';
import GrowthPage from './features/growth';
import AlertsPage from './features/alerts';
import MembersPage from './features/members';
import ManagersPage from './features/managers';
import FarmsPage from './features/farms';
import DevicesPage from './features/devices';
import DeviceModelsPage from './features/device-models';
import NoticePage from './features/notice';
import MessagesPage from './features/messages';
import EmulatorPage from './features/emulator';
import MqttPage from './features/mqtt';

/** 로그인 여부 확인 — 인증 시 새 M3 셸로 감싼다. */
function RequireAuth({ children }: { children: React.ReactNode }): React.ReactElement {
  const token = useAuthStore((s) => s.token);
  if (!token) return <Navigate to="/login" replace />;
  return <Shell>{children}</Shell>;
}

/** ADMIN 전용 페이지 — OPERATOR 이하는 대시보드로 리다이렉트 */
function RequireAdmin({ children }: { children: React.ReactNode }): React.ReactElement {
  const role = useAuthStore((s) => s.user?.role);
  if (role !== 'ADMIN') return <Navigate to="/" replace />;
  return <>{children}</>;
}

function adminRoute(element: React.ReactNode): React.ReactElement {
  return (
    <RequireAuth>
      <RequireAdmin>{element}</RequireAdmin>
    </RequireAuth>
  );
}

export default function App(): React.ReactElement {
  return (
    <Routes>
      <Route path="/login" element={<AuthPage />} />

      {/* 모니터링 (ADMIN + OPERATOR) */}
      <Route path="/" element={<RequireAuth><DashboardPage /></RequireAuth>} />
      <Route path="/data" element={<RequireAuth><DataPage /></RequireAuth>} />
      <Route path="/growth" element={<RequireAuth><GrowthPage /></RequireAuth>} />
      <Route path="/map" element={<RequireAuth><MapPage /></RequireAuth>} />
      <Route path="/alerts" element={<RequireAuth><AlertsPage /></RequireAuth>} />

      {/* 관리 · 소통 (ADMIN 전용) */}
      <Route path="/members" element={adminRoute(<MembersPage />)} />
      <Route path="/managers" element={adminRoute(<ManagersPage />)} />
      <Route path="/farms" element={adminRoute(<FarmsPage />)} />
      <Route path="/devices" element={adminRoute(<DevicesPage />)} />
      <Route path="/models" element={adminRoute(<DeviceModelsPage />)} />
      <Route path="/notice" element={adminRoute(<NoticePage />)} />
      <Route path="/messages" element={adminRoute(<MessagesPage />)} />
      <Route path="/emulator" element={adminRoute(<EmulatorPage />)} />
      <Route path="/mqtt" element={adminRoute(<MqttPage />)} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
